var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconCmsAdmin = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { d: "M22.2,20c0,1.3-1.1,2.3-2.3,2.3s-2.3-1.1-2.3-2.3c0-1.3,1.1-2.3,2.3-2.3S22.2,18.8,22.2,20z" }),
                React.createElement("path", { d: "M25.6,22.4c-0.2,0.5-0.1,1.1,0.2,1.4l0,0c0.6,0.6,0.6,1.5,0,2.2c-0.6,0.6-1.5,0.6-2.2,0l0,0l0,0\n                    c-0.5-0.5-1.3-0.5-1.8,0c-0.2,0.2-0.4,0.6-0.4,0.9v0.1c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5v-0.1c0-0.5-0.4-0.9-0.8-1.2\n                    c-0.5-0.2-1.1-0.1-1.4,0.2l0,0c-0.6,0.6-1.5,0.6-2.2,0c-0.6-0.6-0.6-1.5,0-2.2l0,0l0,0c0.5-0.5,0.5-1.3,0-1.8\n                    c-0.2-0.2-0.6-0.4-0.9-0.4H13c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5c0,0,0,0,0.1,0h0.1c0.5,0,0.9-0.4,1.2-0.8\n                    c0.2-0.5,0.1-1.1-0.2-1.4l0,0c-0.6-0.6-0.6-1.5,0-2.2c0.6-0.6,1.5-0.6,2.2,0l0,0l0,0c0.4,0.4,0.9,0.5,1.4,0.2h0.1\n                    c0.5-0.2,0.8-0.7,0.8-1.2v-0.1c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5c0,0,0,0,0,0.1v0.1c0,0.7,0.6,1.3,1.3,1.3\n                    c0.4,0,0.7-0.1,0.9-0.4l0,0c0.6-0.6,1.5-0.6,2.2,0c0.7,0.6,0.6,1.5,0,2.2l0,0l0,0c-0.4,0.4-0.5,0.9-0.2,1.4v0.1\n                    c0.2,0.5,0.7,0.8,1.2,0.8h0.1c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5h-0.1C26.2,21.6,25.7,21.9,25.6,22.4L25.6,22.4z" })),
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(2.391 2.963)" },
                    React.createElement("path", { d: "M21.3,6.2v-3l-4.8-4.8H5.7 c-1.2,0-2.3,1-2.3,2.3v17.9c0,1.2,1,2.3,2.3,2.3" }),
                    React.createElement("path", { d: "M16.5-1.5v4.8h4.5" })),
                React.createElement("g", { transform: "translate(2.391 2.963)" },
                    React.createElement("path", { d: "M16.5,23.4" }),
                    React.createElement("path", { d: "M0.9,3.2c-1.2,0-2.3,1-2.3,2.3v17.9 c0,1.2,1,2.3,2.3,2.3l0,0h7" }))))));
});
export default IconCmsAdmin;
//# sourceMappingURL=IconCmsAdmin.js.map